<router-outlet />
<p-toast />

@if (loaderService.isLoading()) {
  <div
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50"
  >
    <p-progress-spinner
      strokeWidth="7"
      fill="transparent"
      animationDuration=".8s"
      [style]="{ width: '70px', height: '70px' }"
    />
  </div>
}
